import {
  NOTIFICATION_PENDING_ORDER_ID,
  SCROLL_ORDER_QUERY_ID
} from '@/constants/common'

const ORDER_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/

export const isValidOrderId = (orderId: string): boolean =>
  ORDER_ID_PATTERN.test(orderId)

export const setPendingNotificationOrderId = (orderId: string): boolean => {
  if (!isValidOrderId(orderId)) {
    return false
  }

  sessionStorage.setItem(NOTIFICATION_PENDING_ORDER_ID, orderId)
  return true
}

export const getScrollOrderId = (search: string): string | null => {
  const fromQuery = new URLSearchParams(search).get(SCROLL_ORDER_QUERY_ID)
  if (fromQuery && isValidOrderId(fromQuery)) {
    return fromQuery
  }

  const pendingId = sessionStorage.getItem(NOTIFICATION_PENDING_ORDER_ID)
  if (!pendingId || !isValidOrderId(pendingId)) {
    return null
  }

  sessionStorage.removeItem(NOTIFICATION_PENDING_ORDER_ID)
  return pendingId
}

export const openNewOrderNotificationPage = () => {
  window.open('/orders/new', '_blank', 'noopener,noreferrer')
}

export const openInProgressOrderNotificationPage = () => {
  window.open('/orders/in-progress', '_blank', 'noopener,noreferrer')
}
